export const env = { 
  ...window['env'],
  REACT_APP_GA_TEST_MODE: true,
 }
console.log(env);